import React, { forwardRef, SelectHTMLAttributes } from "react";
import "./Input.scss";

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "prefix"> {
  label?: string;
  error?: string;
  prefix?: React.ReactNode;
}

// 호출부가 실제 `<input>` 에 접근할 수 있어야 한다 — 포커스 복구처럼 DOM 노드가 필요한
// 동작을 래퍼가 가로막으면 안 된다. 기존 사용처는 `ref` 를 넘기지 않으므로 영향이 없다.
export const Input = forwardRef<HTMLInputElement, InputProps>(({ label, error, prefix, className = "", ...props }, ref) => {
  return (
    <div className={`input-wrapper ${className}`}>
      {label && <label className="input-label">{label}</label>}
      <div className={`input-field ${prefix ? "input-field--prefix" : ""} ${error ? "input-field--error" : ""}`}>
        {prefix && <span className="input-prefix">{prefix}</span>}
        <input ref={ref} {...props} />
      </div>
      {error && <span className="input-error">{error}</span>}
    </div>
  );
});
Input.displayName = "Input";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
}

export const Select: React.FC<SelectProps> = ({ label, options, className = "", ...props }) => {
  return (
    <div className={`input-wrapper ${className}`}>
      {label && <label className="input-label">{label}</label>}
      <div className="select-field">
        <select {...props}>
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <span className="select-arrow">▾</span>
      </div>
    </div>
  );
};

export default Input;
